<template>
    <div>
        <div v-if="obj && obj.length > 0">
            <b-list-group-item class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
                Caixa de Entrada
                </b-list-group-item>
            <b-list-group class="list-group-accent" v-for="item in obj" :key="item.id">
                <div class="message">
                <div class="pt-3 mr-3 float-left">
                    <div class="avatar">
                    <img :src="item.message.user.avatar ? item.message.user.avatar : 'img/avatars/admin.png'" class="img-avatar" alt="admin@bootstrapmaster.com">
                    <span class="avatar-status bg-warning" v-show="false"></span>
                    </div>
                </div>
                <div>
                    <small class="text-muted">{{ item.message.user.name }}</small>
                    <small class="text-muted float-right mt-1">{{ $utils.localDate(item.message.messageDate) }}</small>
                </div>
                <div class="text-truncate font-weight-bold"><span class="fa fa-exclamation text-danger" v-show="false"></span> {{ item.message.subject }}</div>
                <div class="small text-muted text-truncate">{{ $utils.parseHtml(item.message.bodyText) }}</div>
                <hr>
                </div>

            </b-list-group>
        </div>
        <div v-else>
            <b-list-group class="list-group-accent">
                <b-list-group-item class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
                Caixa de Entrada
                </b-list-group-item>
                <b-list-group-item href="#" class="list-group-item-accent-danger list-group-item-divider">
                    <small class="text-muted">
                        Nenhuma mensagem recebida.
                    </small>
                </b-list-group-item>
            </b-list-group>
        </div>

    </div>
</template>

<script>
export default {
  name: "AsideMessageComponent",
  props: {
    obj: Array
  },
  data: function() {
    return {
        messages: [
            /*
            {
                "id" : 21312,
                "from" : "Adriana Takamura",
                "online" : false,
                "date" : "11/04/2022 13:52",
                "title" : "Título da mensagem",
                "message" : "Corpo da mensagem Corpo da mensagem Corpo da mensagem Corpo da mensagem",
                "avatar" : "img/avatars/5.jpg",
                "class" : "bg-warning",
            },
            
            {
                "id" : 2543,
                "from" : "André Takamura",
                "online" : false,
                "date" : "11/04/2022 17:00",
                "title" : "Título da mensagem",
                "message" : "Corpo da mensagem",
                "avatar" : "img/avatars/2.jpg",
                "class" : "bg-danger",
            },
            {
                "id" : 5432,
                "from" : "André Takamura",
                "online" : false,
                "date" : "11/04/2022 17:00",
                "title" : "Título da mensagem",
                "message" : "Corpo da mensagem",
                "avatar" : "img/avatars/4.jpg",
                "class" : "bg-primary",
            }
            */
        
        ]
    }  
}
}
</script>